import React from 'react';
import {
  DocumentTextIcon,
  CheckCircleIcon,
  WrenchIcon,
  BeakerIcon,
  TruckIcon
} from '@heroicons/react/24/outline';

const statusStages = [
  { name: 'Quotation Raised', icon: DocumentTextIcon },
  { name: 'Approved', icon: CheckCircleIcon },
  { name: 'Repair Concluded', icon: WrenchIcon },
  { name: 'Test & QA', icon: BeakerIcon },
  { name: 'Delivered', icon: TruckIcon }
];

export default function StatusBar({ jobCard }) {
  let currentStatusIndex = 0;

  // Check approval status
  if (jobCard?.approvalStatus === 'Yes') {
    currentStatusIndex = 1;
  }

  // Check the tracker array to find the latest state
  if (jobCard?.tracker && jobCard?.tracker.length > 0) {
    const lastTrackerState = jobCard.tracker[jobCard.tracker.length - 1].State;
    const trackerIndex = statusStages.findIndex(stage => stage.name === lastTrackerState);
    if (trackerIndex > currentStatusIndex) {
      currentStatusIndex = trackerIndex;
    }
  }

  const progressPercentage = ((currentStatusIndex + 1) / statusStages.length) * 100;

  return (
    <div className="bg-white shadow-sm p-4 border-b border-gray-200">
      <div className="mb-3">
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-sm font-black text-gray-800">Job Progress</h4>
          <span className="text-xs font-bold text-indigo-600">
            {statusStages[currentStatusIndex].name}
          </span>
        </div>

        {/* Progress Bar */}
        <div className="relative">
          <div className="overflow-hidden h-3 rounded-full bg-gray-200">
            <div
              style={{ width: `${progressPercentage}%` }}
              className="h-full rounded-full bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 transition-all duration-500 shadow-md"
            />
          </div>
        </div>
      </div>

      {/* Status Stages */}
      <div className="grid grid-cols-5 gap-2 mt-4">
        {statusStages.map((stage, index) => {
          const Icon = stage.icon;
          const isActive = index <= currentStatusIndex;
          const isCurrent = index === currentStatusIndex;

          return (
            <div key={stage.name} className="flex flex-col items-center">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center mb-1 transition-all ${
                  isActive
                    ? isCurrent
                      ? 'bg-gradient-to-br from-indigo-600 to-purple-600 shadow-lg scale-110'
                      : 'bg-gradient-to-br from-blue-500 to-indigo-500'
                    : 'bg-gray-200'
                }`}
              >
                <Icon className={`h-5 w-5 ${isActive ? 'text-white' : 'text-gray-400'}`} />
              </div>
              <span
                className={`text-xs font-semibold text-center leading-tight ${
                  isActive ? 'text-indigo-700' : 'text-gray-500'
                }`}
              >
                {stage.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
